module.exports = __webpack_public_path__ + "img/torso-flexible-gauged.1d488f6c.png";